import React from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "components/Layout";
import Home from "pages/Home";
import Consultores from "pages/Consultores";
import Registro from "pages/Registro";
import Solicitud from "pages/Solicitud";
import Login from "pages/Login";
import NotFound from "pages/404";
import "./App.css";
import Callback from "pages/Callback";
import Logout from "pages/Logout";
import Profile from "pages/Profile";
import ConsultorDetalle from "pages/Consultores/Detail";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/consultores" element={<Consultores />} />
        <Route path="/registro" element={<Registro />} />
        <Route path="/solicitud" element={<Solicitud />} />
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/profile" element={<Profile/>} />
        <Route path="/consultores/:id" element={<ConsultorDetalle />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
